module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-five.8735c431.jpg";